query GetFund($id: ID!) {
  fund(id: $id) {
    id
    name
    preferredName
    fundGroup {
      id
      name
    }
    fundRecordType {
      id
      name
      description
    }
    legalEntity {
      id
      name
    }
    legacyPlan
    legacyPlanNotes
    impactReportingContact {
      id
      name
    }
    fundAccounts {
      id
      currency
      sageCode
      totalClearedBalance {
        minorUnit
        currency
      }
      totalLiquidBalance {
        minorUnit
        currency
      }
      totalClearedIncoming {
        minorUnit
        currency
      }
      totalClearedOutgoing {
        minorUnit
        currency
      }
      totalWorkingBalance {
        minorUnit
        currency
      }
      totalWorkingIncoming {
        minorUnit
        currency
      }
      totalWorkingOutgoing {
        minorUnit
        currency
      }
      totalIlliquidBalance {
        minorUnit
        currency
      }
      investmentActivity {
        minorUnit
        currency
      }
      fees {
        minorUnit
        currency
      }
      incoming {
        minorUnit
        currency
      }
      outgoing {
        minorUnit
        currency
      }
      pendingOutgoingGrants {
        minorUnit
        currency
      }
      pendingFees {
        minorUnit
        currency
      }
      availableForGrantMaking {
        minorUnit
        currency
      }
    }
    notes
    openDate
    closedDate
    fundStatus
    salesforceId
    dafPlan
    processingFeeExemption
    adminFeeExemption
    investmentAllocation
    feeStartDate
    fundManagers {
      id
      employee {
        id
        name
        email
        salesforceId
      }
    }
    dafAdvisors {
      id
      contact {
        id
        name
        email
        salesforceId
      }
      accessLevel
      signedTermsAndConditions
      removed
      needsConfirmation
    }
  }
}
